import { YodaFieldValue } from 'yoda-ui/yodaForm/yodaForm.types';

export const strategicImperativeToBE = (data: YodaFieldValue) => {
  return {
    title: data.title,
    description: data.description,
    country: data.country,
    therapeuticArea: data.therapeuticArea,
    year: data.year,
  };
};

